import React from "react";
import { Empty } from "antd";

const NotFound = () => {
  return <Empty description="La página que buscas no existe!" />;
};

export default NotFound;
